import { render, staticRenderFns } from "./AddCommunity.vue?vue&type=template&id=4410679e&scoped=true&"
import script from "./AddCommunity.vue?vue&type=script&lang=js&"
export * from "./AddCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410679e",
  null
  
)

export default component.exports